/**
 * The Context scope picker's strings (`ContextScopePicker`): `""` for every AI request,
 * `area:<id>` or `project:<id>` for one area or project - and back to the API's two fields.
 */

import type { ContextEntry, ContextScopeType } from "./api";

export const scopeValue = (entry: Pick<ContextEntry, "scope_type" | "scope_id">): string =>
  entry.scope_type === "all" ? "" : `${entry.scope_type}:${entry.scope_id}`;

export function scopeOf(value: string): {
  scope_type: ContextScopeType;
  scope_id: string | null;
} {
  const [type, id] = value.split(":");
  return type === "area" || type === "project"
    ? { scope_type: type, scope_id: id }
    : { scope_type: "all", scope_id: null };
}
